<template>
    <v-footer style="min-height: 554px; background-color: black;">
        <v-container>
            <v-row justify="center" class="mb-12 align-center justify-center">
                <v-col cols="12">
                    <div class="partner title">{{ $t('footer.partners') }}</div>
                </v-col>
                <v-col cols="12" md="2" class="text-center pb-0 d-flex justify-center align-center text-center">
                    <v-img @click="linkOut('magnumwines.cz')" src="@/assets/partners/Magnum_wines_logo_mini.jpg"
                        alt="magnumwines.cz" class="partner-image" width="130" max-width="130" eager />
                </v-col>

                <v-col cols="12" md="4" class="text-center pb-0 d-flex justify-center align-center text-center">
                    <v-img @click="linkOut('rosterhockey.cz')" src="@/assets/partners/roster.webp" class="partner-image"
                        alt="rosterhockey.cz" width="300" max-width="300" eager />
                </v-col>

                <v-col cols="12" class="text-center pb-0">
                    <v-img @click="linkOut('opportunity.cz')" src="@/assets/partners/Opportunity_logo_mini.webp"
                        class="partner-image" alt="opportunity.cz" height="300" eager />
                </v-col>

                <v-col cols="12" class="text-center pb-0">
                    <v-img @click="linkOut('ccmbrno.cz')" src="@/assets/partners/ccm.png"
                        class="partner-image" alt="ccmbrno.cz" height="90" />
                </v-col>
                <v-col cols="12" class="text-center pb-0">
                    <v-img @click="linkOut('sportrec.cz')" src="@/assets/partners/Sport_Recovery.webp"
                        class="partner-image" alt="sportrec.cz" height="150" />
                </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
                <v-col cols="12" class="text-center pb-0">
                    <span @click="goToGdpr" class="ml-1 text-white href">{{ $t('footer.terms') }}</span>
                </v-col>
                <v-col cols="12" class="text-center pt-0">
                    © {{ currentYear }} Modern Hockey
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { linkOut } from '@/utils/navigateUtils';

const { t } = useI18n({ useScope: 'global' });
const router = useRouter();

// Funkce pro přesměrování na GDPR stránku
const goToGdpr = () => {
    router.push('/gdpr-modernhockey');
};

// Získání aktuálního roku
const currentYear = new Date().getFullYear();
</script>

<style scoped>
.v-footer {
    color: white;
    cursor: pointer;
}


.partner-image {

    border-radius: 5px;
}
</style>
